import React from 'react';
import classNames from 'classnames';
import Field from '../../platformui/Forms/field';
import Alert from '../../platformui/Alert';
import { Formik } from 'formik';

const ErrorMessage = (props) => {
  return props.InfoMessage ? (
    <div className="c-forms__error">{props.InfoMessage}</div>
  ) : null;
};

const ReadReply = (props) => {
  const validate = (values) => {
    const errors = {};
    const name = props.Reply.Form.ControlNumberField.Name;

    if (values[name].length <= 7) {
      errors[name] = 'minLength';
    }

    return errors;
  };

  const { ControlNumberField, SubmitButton, ServiceIsOpen, InfoMessage } =
    props.Reply.Form;

  const InputClass = classNames({
    'c-forms__input': true,
    'c-forms__input--is-error': InfoMessage,
  });

  const initialValues = {
    [ControlNumberField.Name]: ControlNumberField.Value || '',
  };

  return (
    <section className="c-read-reply">
      {!ServiceIsOpen && props.Reply.Form.ErrorMessage && (
        <Alert type="warning">{props.Reply.Form.ErrorMessage}</Alert>
      )}

      <div className="c-read-reply__submit-container">
        <Formik validate={validate} initialValues={initialValues}>
          {(formik) => (
            <form noValidate onSubmit={formik.submitForm} method="post">
              <label
                htmlFor={ControlNumberField.Name}
                dangerouslySetInnerHTML={{ __html: props.Preamble }}
              ></label>
              <Field
                component="input"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                className={InputClass}
                type="text"
                disabled={!ServiceIsOpen}
                value={formik.values[ControlNumberField.Name]}
                placeholder={ControlNumberField.Placeholder}
                isValid={true /* !formik.errors[ControlNumberField.Name]} */}
                isTouched={formik.touched[ControlNumberField.Name]}
                name={ControlNumberField.Name}
                label={ControlNumberField.Label}
              />
              <ErrorMessage InfoMessage={InfoMessage} />
              <button
                className="c-forms__button"
                type="submit"
                disabled={formik.isSubmitting}
              >
                {SubmitButton.Label}
              </button>
            </form>
          )}
        </Formik>
      </div>
    </section>
  );
};

export default ReadReply;
